module.exports = __webpack_public_path__ + "static/media/customer-5.1f6e20a1.jpg";